import { createSlice } from '@reduxjs/toolkit';

const hpElectricSwitchSlice = createSlice({
  name: 'hpElectricSwitch',
  initialState: {},
  reducers: {
    hpEcHandleUnSelectIndividualMachine: (state, action) => {
      state[action.payload.location][action.payload.machine].isSelected = false;
    },
    hpEcSpecificLocationSelectMachinesHandler: (state, action) => {
      state[action.payload.location][action.payload.specificLocation][
        action.payload.machine
      ].isSelected = true;
    },
    hpEcHandleSelectIndividualMachine: (state, action) => {
      state[action.payload.location][action.payload.machine].isSelected = true;
    },
    hpEcSpecificLocationUnselectMachinesHandler: (state, action) => {
      state[action.payload.location][action.payload.specificLocation][
        action.payload.machine
      ] = false;
    },
  },
});

export default hpElectricSwitchSlice;
export const selectHpElectricSwitch = (state) => state.hpElectricSwitch;
export const {
  hpEcHandleUnSelectIndividualMachine,
  hpEcHandleSelectIndividualMachine,
  hpEcSpecificLocationSelectMachinesHandler,
  hpEcSpecificLocationUnselectMachinesHandler,
} = hpElectricSwitchSlice.actions;
